import React, { useEffect, useState } from "react";

function getPublicationAboutApiBase() {
    const explicit = process.env.REACT_APP_API_URL?.replace(/\/$/, "");
    if (explicit) return `${explicit}/publication-about`;
    if (process.env.NODE_ENV === "development") return "/publication-about";
    return "https://backend.impactjournal.co.in/publication-about";
}

const API_BASE = getPublicationAboutApiBase();

const ROW_CONFIG = [
    { key: "journal_title", label: "Journal Title" },
    { key: "starting_year", label: "Starting Year" },
    { key: "frequency", label: "Frequency" },
    { key: "format", label: "Format" },
    { key: "subject", label: "Subject" },
    { key: "language", label: "Language" },
    { key: "publisher_name", label: "Publisher Name" },
    { key: "publisher_address", label: "Publisher Address" },
    { key: "email", label: "Email" },
    { key: "website", label: "Website" },
];

function normalizeWebsiteHref(raw) {
    const s = (raw || "").trim();
    if (!s) return null;
    if (/^https?:\/\//i.test(s)) return s;
    return `https://${s}`;
}

function EmailCell({ value }) {
    if (!value || !String(value).trim()) return "—";
    const parts = String(value)
        .split(/\s*\/\s*/)
        .map((p) => p.trim())
        .filter(Boolean);
    return (
        <>
            {parts.map((part, i) => {
                const hasAt = part.includes("@");
                const inner = hasAt ? (
                    <a href={`mailto:${part.replace(/^mailto:/i, "")}`}>{part}</a>
                ) : (
                    <span>{part}</span>
                );
                return (
                    <span key={i}>
                        {i > 0 ? " / " : null}
                        {inner}
                    </span>
                );
            })}
        </>
    );
}

function WebsiteCell({ value }) {
    if (!value || !String(value).trim()) return "—";
    const href = normalizeWebsiteHref(value);
    return (
        <a href={href} target="_blank" rel="noopener noreferrer">
            {value.trim()}
        </a>
    );
}

const AboutThePublication = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        void (async () => {
            try {
                const res = await fetch(API_BASE);
                if (!res.ok) throw new Error("Failed to load");
                const json = await res.json();
                if (!cancelled) setData(json);
            } catch (e) {
                if (!cancelled) setError("Could not load publication details.");
            } finally {
                if (!cancelled) setLoading(false);
            }
        })().catch(() => {});
        return () => {
            cancelled = true;
        };
    }, []);

    const renderValue = (key, raw) => {
        if (key === "email") return <EmailCell value={raw} />;
        if (key === "website") return <WebsiteCell value={raw} />;
        if (!raw || !String(raw).trim()) return "—";
        return raw;
    };

    return (
        <div className="about-ed-wrapper-impact">
            <h2 className="about-ed-heading-impact">About the Publication</h2>
            <div className="about-ed-table-container-impact">
                {loading && <p className="about-ed-content-impact">Loading…</p>}
                {error && <p className="about-ed-content-impact">{error}</p>}
                {!loading && !error && data && (
                    <table className="about-ed-table-impact about-publication-table-impact">
                        <thead>
                            <tr>
                                <th>Details</th>
                                <th>Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ROW_CONFIG.map(({ key, label }) => (
                                <tr key={key}>
                                    <td>{label}</td>
                                    <td>{renderValue(key, data[key])}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default AboutThePublication;
